import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CreateExternalLinkTo, LinkTo } from "../../../constants/linkTo";
import { AppTester } from "../../../../supporting";
import { ComingSoonTab } from "../components/ComingSoonTab";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

export const useGetShopTabs = () => {

    const { t, i18n: { language } } = useTranslation();
    const isFashionDeziiign = AppTester.isFashionDeziiign();
    const location = useLocation();
    const brandsBaseUrl = CreateExternalLinkTo.shopBrands('?team=161ed0e49efb4bf0b03e81cb09638606%2Ce2718ce5065749a09c9ab1dd801efd68');
    const brandsUrlWithParams = `${brandsBaseUrl}&cat=aa2343a2dd355786249bc04579b25d51%2Ccb0773a2dd934908949ad04579b25d45`;

    const brandsUrl = isFashionDeziiign ? brandsUrlWithParams : brandsBaseUrl;

    return {
        [NAVBAR_TAB_NAMES.shop_disabled]: {
            content: <ComingSoonTab>{t('nav.shop')}</ComingSoonTab>,
            active: location.pathname.startsWith(LinkTo.ShopLocal),
            disabled: true,
        },
        [NAVBAR_TAB_NAMES.shop_deziiign]: {
            content: t('nav.shop'),
            active: location.pathname.startsWith(LinkTo.ShopLocal),
            linkTo: brandsUrl,
            external: true,
        },
        [NAVBAR_TAB_NAMES.shop_galllery_art]: {
            content: t('nav.shop'),
            active: location.pathname.startsWith(LinkTo.ShopLocal),
            linkTo: CreateExternalLinkTo.shopGalllery(`?page=1&lang=${language}`),
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.shop_local]: {
            content: t('nav.shop'),
            linkTo: LinkTo.ShopLocal,
        },
    }
}import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CreateExternalLinkTo, LinkTo } from "../../../constants/linkTo";
import { AppTester } from "../../../../supporting";
import { ComingSoonTab } from "../components/ComingSoonTab";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

export const useGetShopTabs = () => {

    const { t, i18n: { language } } = useTranslation();
    const isFashionDeziiign = AppTester.isFashionDeziiign();
    const location = useLocation();
    const brandsBaseUrl = CreateExternalLinkTo.shopBrands('?team=161ed0e49efb4bf0b03e81cb09638606%2Ce2718ce5065749a09c9ab1dd801efd68');
    const brandsUrlWithParams = `${brandsBaseUrl}&cat=aa2343a2dd355786249bc04579b25d51%2Ccb0773a2dd934908949ad04579b25d45`;

    const brandsUrl = isFashionDeziiign ? brandsUrlWithParams : brandsBaseUrl;

    return {
        [NAVBAR_TAB_NAMES.shop_disabled]: {
            content: <ComingSoonTab>{t('nav.shop')}</ComingSoonTab>,
            active: location.pathname.startsWith(LinkTo.ShopLocal),
            disabled: true,
        },
        [NAVBAR_TAB_NAMES.shop_deziiign]: {
            content: t('nav.shop'),
            active: location.pathname.startsWith(LinkTo.ShopLocal),
            linkTo: brandsUrl,
            external: true,
        },
        [NAVBAR_TAB_NAMES.shop_galllery_art]: {
            content: t('nav.shop'),
            active: location.pathname.startsWith(LinkTo.ShopLocal),
            linkTo: CreateExternalLinkTo.shopGalllery(`?page=1&lang=${language}`),
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.shop_local]: {
            content: t('nav.shop'),
            linkTo: LinkTo.ShopLocal,
        },
    }
}